import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootReducer } from 'redux/reducers';
import { selectActiveDsTab } from 'redux/mode/reducers';
import { setDesignSystemFilterCategories } from 'redux/mode/actions';
import AllTokensView from './AllTokensView';

const ThemeView = () => {
	const dispatch = useDispatch();
	const activeTab = useSelector((r: RootReducer) => selectActiveDsTab(r.mode));
	const contentPath = activeTab?.contentPath;

	// Graceful migration: if someone had a "colors" tab bookmarked,
	// auto-select the colors filter pill so they see the right section
	useEffect(() => {
		if (contentPath === 'colors') {
			dispatch(setDesignSystemFilterCategories({ section: 'theme', categories: ['color'] }));
		}
	}, [contentPath, dispatch]);

	return <AllTokensView />;
};

export default ThemeView;
